import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import buildAnimation from '../../assets/build.json';

const MESSAGES = [
  'Analyzing your music…',
  'Organizing your content…',
  'Building your profile…',
];

interface BuildingProfileOverlayProps {
  visible: boolean;
}

const BuildingProfileOverlay: React.FC<BuildingProfileOverlayProps> = ({ visible }) => {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    if (!visible) {
      setMsgIndex(0);
      return;
    }
    const interval = setInterval(() => {
      setMsgIndex((prev) => (prev + 1) % MESSAGES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-primary backdrop-blur-sm rounded-2xl">
      {/* Lottie Animation */}
      <div className="mb-6 w-100 h-100">
        <Lottie animationData={buildAnimation} loop={true} />
      </div>

      {/* Rotating message */}
      <p
        key={msgIndex}
        className="text-lg font-semibold text-white animate-in fade-in slide-in-from-bottom-2 duration-400"
      >
        {MESSAGES[msgIndex]}
      </p>

      <p className="text-sm text-white mt-2">
        This usually takes a few seconds
      </p>
    </div>
  );
};

export default BuildingProfileOverlay;
